import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDown2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 6.312 7.215",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1.5,
		"data-name": "Icon - Arrow Down Small",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "m.53 3.529 2.625 2.626 2.626-2.626",
			"data-name": "Path 5615"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M3.156 6.154 3.157 0",
			"data-name": "Line 1119"
		})]
	})
});
export { SvgArrowDown2 as ReactComponent };
